<template>
    <div>
        <transition-group
            name="custom-classes-transition"
            mode="out-in"
            enter-active-class="animated fadeInRight"
            leave-active-class="animated fadeOutLeft"
        >
            <section class="padding-vertical-content" v-if="paso == 1" key="paso1" id="paso1">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="h1 text-uppercase">{{ $t('partido.buscar_abono', {abono: teatro.texto_abono}) }}</h2>
                        </div>
                        <div class="col-12 col-lg-6 mb-3">
                            <ContentOrLoading>
                                <BuscarAbonado 
                                    v-if="! loading"
                                    :error="error" 
                                    :data="data"
                                    @buscarAbonado="buscarAbono"
                                />
                            </ContentOrLoading>                        
                        </div>
                        <div class="col-12 col-lg-6">
                            <AvisosVentaDiaAbonado/>
                        </div>
                    </div>
                </div>
            </section>

            <section class="padding-vertical-content" v-if="paso == 2" key="paso2" id="paso2">
                <div class="container">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <label for="precios">Selecciona un precio</label>
                                <ValidationProvider name="precio" id="precios" rules="required" v-slot="{ errors }">
                                    <multiselect
                                        v-model="data.precio"
                                        placeholder="Selecciona un precio"
                                        label="description"
                                        track-by="id"
                                        :options="precios"
                                        :multiple="false"
                                    />
                                    <span v-if="errors[0]" class="error invalid-feedback" style="display: block;">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-lg-4">
                                <FormInput :label="$t('formularios.nombre')" id="nombre" :name="$t('formularios.nombre')" rules="required" v-model="data.nombre" />
                            </div>
                            <div class="col-12 col-lg-4">
                                <FormInput :label="$t('formularios.apellidos')" id="apellidos" :name="$t('formularios.apellidos')" rules="required" v-model="data.apellidos" />
                            </div>
                            <b-col cols="12" md="6" lg="4">
                                <DocumentoTipo
                                    :value="data.tipoDocumentoSeleccionado"
                                    @input="val => { data.tipoDocumentoSeleccionado = val; }"
                                />
                            </b-col>
                            <b-col cols="12" md="6" lg="4">
                                <DocumentoValor
                                    :type="data.tipoDocumentoSeleccionado"
                                    :value="data.dni"
                                    @input="val => { data.dni = val; }"
                                />
                            </b-col>
                            <div class="col-12 col-lg-6">
                                <div class="form-group">
                                    <label for="nombre">Email</label>
                                    <ValidationProvider name="email" rules="required|email" vid="confirmation" mode="passive" v-slot="{ errors }">
                                        <input type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Email" v-model="data.email"/>
                                        <span class="error">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="form-group">
                                    <label>{{ $t('formularios.confirmar_email') }}</label>
                                    <ValidationProvider :name="$t('formularios.confirmar_email')" :rules="'required|confirmed_ci:@confirmation'" mode="passive" v-slot="{ errors }">
                                        <input type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.confirmar_email')" v-model="data.email_confirmation" id="email_confirmation"/>
                                        <span class="error">{{ errors[0] }}</span>
                                    </ValidationProvider>                            
                                </div>
                            </div>
                            <div class="col-12" v-if="error">
                                <span class="error">{{ error.response.errorCodeMsg }}</span>
                            </div>

                            <div class="col-12 mt-3">
                                <button type="submit" class="button" :disabled="loading">Continuar</button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
            </section>

            <section class="padding-vertical-content" v-if="paso == 3" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ResumenComponent :precio="data.precio" :formulario_compra="data.formulario_compra" :jet_id="jet_id" :event="evento" :desactivar="procesar_pago" @compraPaycomet="procesarPagoPaycomet()" />
                        </div>
                    </div>
                </div>
            </section>

            <section class="padding-vertical-content lightgray-content" v-if="procesar_pago" key="pago" id="pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent
                                ref="pago"
                                tipo_venta="venta-dia-abonado-lfp"
                                :jet_id="jet_id"
                                :session_id="session_id"
                            />		
                        </div>
                    </div>
                </div>
            </section>
        </transition-group>
    </div>
</template>

<script>
    import BuscarAbonado from '@/components/frontend/lfp/BuscarAbonado';
    import AvisosVentaDiaAbonado from '@/components/frontend/events/compra/AviosVentaDiaAbonado';
    import ResumenComponent from '@/components/frontend/events/compra/components/lfp/dia_abonado/ResumenComponent';
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";

    export default {
        props: ['evento', 'sesion_id'],
        data() {
            return {
                data: {
                    n_abonado: "",
                    pin: "",
                    formulario_compra: "",
                    tipoDocumentoSeleccionado: "null",
                    dni: ""
                },
                paso: 1,
                error: null,
                loading: false,
                precios: [],
                jet_id: "",
                session_id: null,
                procesar_pago: false
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            buscarAbono(data) {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    pin: data.pin,
                    id_persona: data.id_persona,
                    sesion_id: this.sesion_id,
                    event_id: this.evento.id
                }

                this.$store.dispatch(this.config.getVuexAlias('lfp.partidos.sesion.abonados.precios'), params).then(res => {
                    this.precios = res.data.precios;
                    if(this.precios.length == 1) {
                        this.data.precio = this.precios[0];
                    }
                    this.paso = 2;
                }).catch(error => {
                    this.error = error.response.data;
                }).finally(() => this.loading = false);
            },
            realizarReserva() {
                this.loading = true;
                let params = this.data;
                params.sesion_id = this.sesion_id;
                params.event_id = this.evento.id;
                params.filters = {
                    tid: this.configuracion.hash_teatro
                };

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                this.$store.dispatch(this.config.getVuexAlias('lfp.partidos.sesion.reservar.asiento.socio'), params).then(res => {
                    if (res.data.jet_id) {
                        this.jet_id = res.data.jet_id;
                    } else {
                        this.data.formulario_compra = res.data.formulario_compra;
                    }
                    this.session_id = res.data.session_id;
                    this.paso = 3;
                }).catch(error => {
                    this.error = error.response.data;
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.realizarReserva();
                }
            },
            procesarPagoPaycomet() {
                this.procesar_pago = true;
                this.$nextTick(() => {
                    this.$scrollTo('#pago', 1000);
                })
            }
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }
        },
        created() {
            this.data.tipoDocumentoSeleccionado = 'DNI';
        },
        components: {
            BuscarAbonado, AvisosVentaDiaAbonado, ResumenComponent, PagoPaycometComponent, DocumentoTipo, DocumentoValor
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>